class SizeSplitter extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onProxyChange.bind(this));
  }

  onProxyChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.dataset.sizeProxy) return;

    const selectedWaists = new Set(
      [...this.querySelectorAll('[data-size-proxy="waist"]:checked')].map((el) => el.value)
    );
    const selectedLengths = new Set(
      [...this.querySelectorAll('[data-size-proxy="length"]:checked')].map((el) => el.value)
    );

    const noneSelected = selectedWaists.size === 0 && selectedLengths.size === 0;

    this.querySelectorAll('[data-size-combo]').forEach((input) => {
      const waistOk = selectedWaists.size === 0 || selectedWaists.has(input.dataset.waist);
      const lengthOk = selectedLengths.size === 0 || selectedLengths.has(input.dataset.length);
      input.checked = !noneSelected && waistOk && lengthOk;
    });

    target.closest('label')?.classList.toggle('is-active', target.checked);
  }
}

if (!window.customElements.get('size-splitter')) {
  window.customElements.define('size-splitter', SizeSplitter);
}
